import React, { useState } from 'react';

import { useNavigate } from 'react-router-dom';
import useAlert from '../../hooks/useAlert';
import {ucwords} from "../../utils";
import ContattoBtns from "./ContattoBtns";

// Righe di contatti con espansione dettagli
const ContactListRow = ({ contact, setRawList, selectedList, handleSelectContact }) => {
    const navigate = useNavigate();
    const { id, numtel, cognome, nome, data_creazione, blocco, priorita, hanoteprerisposta} = contact;
    const [expanded, setExpanded] = useState(false);
    const alert = useAlert();
    // Converti il cognome in lowercase con tutte le iniziali maiuscole
    let cognomeLower = ucwords(cognome);
    let nomeLower = ucwords(nome);
    
    const handleContactClick = () => setExpanded(prev => !prev);

    return (
        <div className={`vista-row`} data-numero={numtel}>
            <div className="vista-row-info">
                <div className="sx">
                    <input type="checkbox" className="select-checkbox" onChange={() => handleSelectContact(id)} checked={selectedList.includes(id)}/>
                    <div className="item sameline" onClick={handleContactClick} style={{height: "50px"}}>
                        <span className="title text-trunc-ellipsis">{cognomeLower}&nbsp;<span className='title-v2'>{nomeLower}</span></span>
                        <span className="subtitle text-trunc-ellipsis">{numtel}</span>
                    </div>                  
                </div>
            </div>
            <div className="vista-row-actions">
                {expanded && <ContattoBtns itemGroup={contact} setRawList={setRawList} />}
            </div>
        </div>
    );
}

export default ContactListRow;